  <app-header></app-header>

  @if (isSearchPage) {
    <app-search-filter id="filter"></app-search-filter>
  }

  <div class="content min-h-[100vh]">
    <router-outlet></router-outlet>
  </div>

  <app-footer class="footer"></app-footer>


  <app-chatbot [shouldDisplay]="isHomePage || isSearchPage"></app-chatbot>
